import { useHomeBanner, useFontSizeData } from '@/src/api/getData';
import Banner from '@/components/banner';

const FontSizeView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: fontSizeData } = useFontSizeData(language);
    let fontSizeDataContent = fontSizeData?.data || {};

    return (
        <main className='theme-normal format-normalEditor'>
            <Banner banner={banner} category="Font Size" />
            <section className="contact-details container" id="start">
                <h2>{fontSizeDataContent.Header}</h2>
                {fontSizeDataContent.Editor
                    ? <div className='Content' dangerouslySetInnerHTML={{ __html: fontSizeDataContent.Editor }} />
                    : null
                }
            </section>
        </main>
    );
}

export default FontSizeView;